import React, { useState } from 'react';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css'; 

// Helper component for icons
const Icon = ({ path, className = "icon" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d={path} />
  </svg>
);

// Icons paths
const ICONS = {
  email: "M3 3.75A1.75 1.75 0 0 1 4.75 2h14.5A1.75 1.75 0 0 1 21 3.75v16.5A1.75 1.75 0 0 1 19.25 22H4.75A1.75 1.75 0 0 1 3 20.25V3.75Zm.75 0V20.25c0 .414.336.75.75.75h14.5a.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0-.75.75Zm9.25 5.5a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5Z",
  lock: "M12 1.75a4.75 4.75 0 0 0-4.75 4.75v2.5H6.5a2.75 2.75 0 0 0-2.75 2.75v8.5A2.75 2.75 0 0 0 6.5 23h11a2.75 2.75 0 0 0 2.75-2.75v-8.5A2.75 2.75 0 0 0 17.5 9H16V6.5A4.75 4.75 0 0 0 12 1.75Zm3.5 7.25h-7v-2.5a3.25 3.25 0 0 1 6.5 0v2.5Zm-9.25 1.5a1.25 1.25 0 0 1 1.25-1.25h11a1.25 1.25 0 0 1 1.25 1.25v8.5a1.25 1.25 0 0 1-1.25 1.25h-11a1.25 1.25 0 0 1-1.25-1.25v-8.5Z",
  arrow: "M13.28 3.22a.75.75 0 0 0-1.06 1.06L15.94 8l-3.72 3.72a.75.75 0 1 0 1.06 1.06l4.25-4.25a.75.75 0 0 0 0-1.06l-4.25-4.25Z"
};

const MailIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
    </svg>
);

const LockIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 00-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
    </svg>
);

const KeyIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
    </svg>
);

const CheckCircleIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const CloseIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);


// --- Reusable Components with CSS classes ---
const InputField = ({ id, type, placeholder, value, onChange, icon, error }) => (
    <div className="input-field-container">
        <span className="input-field-icon">
            {icon}
        </span>
        <input
            id={id}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`input-field ${error ? 'input-field--error' : ''}`}
        />
        {error && <p className="input-field__error-text">{error}</p>}
    </div>
);

const ActionButton = ({ onClick, disabled, children, isLoading }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        className="action-button"
    >
        {isLoading && (
            <svg className="action-button__spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        )}
        {children}
    </button>
);

const ForgotPasswordFlow = ({onClose, role}) => {
    const [step, setStep] = useState('email'); // 'email', 'otp', 'password', 'success'
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({});

    const validateEmail = (email) => {
        if (!email) return "Email is required.";
        if (!/\S+@\S+\.\S+/.test(email)) return "Email address is invalid.";
        return null;
    };
    
    const validateOtp = (otp) => {
        if (!otp) return "OTP is required.";
        if (otp.length < 6) return "OTP must be at least 6 characters.";
        return null;
    };

    const validatePassword = (password) => {
        if (!password) return "Password is required.";
        if (password.length < 6) return "Password must be at least 6 characters long.";
        return null;
    };

    const handleSendOtp = async () => {
        const emailError = validateEmail(email);
        if (emailError) {
            setError({ email: emailError });
            return;
        }
        
        setIsLoading(true);
        setError({});
        try {
            console.log('role:', role);
            const res = await axios.post('https://ethiccraft.org/backend/Facilitator_Panel/forget_password_send_otp.php', { email, role });
            if (res.status === 200 && res.data.message?.includes('OTP')) {
                setStep('otp');
            } else {
                setError({ api: res.data.message || 'Failed to send OTP. Please check the email and try again.' });
            }
        } catch (err) {
            setError({ api: err.response?.data?.error + '  ' +  err.response?.data?.message || 'An unexpected error occurred.' });
        } finally {
            setIsLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        const otpError = validateOtp(otp);
        if (otpError) {
            setError({ otp: otpError });
            return;
        }

        setIsLoading(true);
        setError({});
        try {
            const res = await axios.post('https://ethiccraft.org/backend/forget_password/verify_otp.php', { email, otp, role });
            if (res.status === 200 && res.data.message?.includes('OTP verified')) {
                setStep('password');
            } else {
                setError({ api: res.data.message || 'Invalid OTP. Please try again.' });
            }
        } catch (err) {
            setError({ api: err.response?.data?.message || 'An unexpected error occurred.' });
        } finally {
            setIsLoading(false);
        }
    };

    const handleResetPassword = async () => {
        const passwordError = validatePassword(newPassword);
        if (passwordError) {
            setError({ password: passwordError });
            return;
        }

        setIsLoading(true);
        setError({});
        try {
            const res = await axios.post('https://ethiccraft.org/backend/Facilitator_Panel/forget_password.php', { email, new_password: newPassword, role });
            if (res.status === 200 && res.data.message?.includes('success')) {
                setStep('success');
            } else {
                setError({ api: res.data.message || 'Failed to reset password.' });
            }
        } catch (err) {
            setError({ api: err.response?.data?.message || 'An unexpected error occurred.' });
        } finally {
            setIsLoading(false);
        }
    };

    const renderStep = () => {
        switch (step) {
            case 'email':
                return (
                    <>
                        <h2 className="modal__title">Forgot Password?</h2>
                        <p className="modal__subtitle">Enter your registered email to receive an OTP.</p>
                        <InputField
                            id="email"
                            type="email"
                            placeholder="your@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            icon={<MailIcon className="icon" />}
                            error={error.email}
                        />
                        <div className="modal__action">
                            <ActionButton onClick={handleSendOtp} disabled={isLoading} isLoading={isLoading}>
                                {isLoading ? 'Sending...' : 'Send OTP'}
                            </ActionButton>
                        </div>
                    </>
                );
            case 'otp':
                return (
                    <>
                        <h2 className="modal__title">Verify OTP</h2>
                        <p className="modal__subtitle">An OTP has been sent to <span className="modal__highlight">{email}</span>.</p>
                        <InputField
                            id="otp"
                            type="text"
                            placeholder="Enter 6-digit OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            icon={<KeyIcon className="icon" />}
                            error={error.otp}
                        />
                        <div className="modal__action">
                            <ActionButton onClick={handleVerifyOtp} disabled={isLoading} isLoading={isLoading}>
                                {isLoading ? 'Verifying...' : 'Verify OTP'}
                            </ActionButton>
                        </div>
                    </>
                );
            case 'password':
                return (
                    <>
                        <h2 className="modal__title">Set New Password</h2>
                        <p className="modal__subtitle">Create a new, strong password for your account.</p>
                        <InputField
                            id="newPassword"
                            type="password"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            icon={<LockIcon className="icon" />}
                            error={error.password}
                        />
                        <div className="modal__action">
                            <ActionButton onClick={handleResetPassword} disabled={isLoading} isLoading={isLoading}>
                                {isLoading ? 'Resetting...' : 'Reset Password'}
                            </ActionButton>
                        </div>
                    </>
                );
            case 'success':
                return (
                    <div className="modal__success-content">
                        <CheckCircleIcon className="icon--success" />
                        <h2 className="modal__title">Password Reset!</h2>
                        <p className="modal__subtitle">Your password has been successfully reset. You can now log in with your new password.</p>
                         <div className="modal__action">
                            <ActionButton onClick={onClose}>
                                Back to Login
                            </ActionButton>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button onClick={onClose} className="modal__close-button" aria-label="Close">
                    <CloseIcon className="icon" />
                </button>
                {error.api && (
                    <div className="api-error-message" role="alert">
                        <p className="api-error-message__title">Error</p>
                        <p>{error.api}</p>
                    </div>
                )}
                {renderStep()}
            </div>
        </div>
    );
};

// The onLogin prop is passed from the parent component (like App.js)
// to update the application's authentication state.
const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // FIX: Initialize role with a default value to prevent errors.
  const [role, setRole] = useState('facilitator');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const navigate = useNavigate();

  const apiEndpoints = {
    facilitator: 'https://ethiccraft.org/backend/Facilitator_Panel/facilitator_login.php',
    area_leader: 'https://ethiccraft.org/backend/Facilitator_Panel/arealeader_login.php',
    admin: 'https://ethiccraft.org/backend/Admin_Login_In_Facilitatator_Panel/login.php',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Ensure a role is selected.
    if (!role) {
        setError('Please select a role to continue.');
        Swal.fire({ icon: 'warning', title: 'Role not selected', text: 'Please select a role before signing in.' });
        return;
    }

    setIsSubmitting(true);
    const endpoint = apiEndpoints[role];

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        credentials: 'include',
      });
      
      const result = await response.json();

      const isLoginSuccess = response.ok && (result.success === true || result.status === 'success') && result.message?.toLowerCase().includes('login successful');

      if (isLoginSuccess) {
        Cookies.set('role', role, { expires: 7 });
        Cookies.set('email', result.email || email, { expires: 7 });
        Cookies.set('username', result.username || '', { expires: 7 });
        if (result.session_id) Cookies.set('token', result.session_id, { expires: 7 });
        if (role === 'facilitator') Cookies.set('Mentorsemail', result.email || email, { expires: 7 });
        
        // If onLogin prop is provided, call it to update parent state
        if(onLogin) {
          onLogin(role);
        }

        Swal.fire({
          title: `🎉 Welcome ${result.username || ''}!`,
          html: 'Login successful. Redirecting...',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          timerProgressBar: true,
        });
        // This navigation will now work correctly
        setTimeout(() => navigate('/students-data'), 1500);
      } else {
        const errorMessage = result.error || result.message || 'Invalid email or password.';
        Swal.fire({ icon: 'error', title: 'Login Failed', text: errorMessage });
        setError(errorMessage);
      }
    } catch (err) {
      console.error('❌ Login Error:', err);
      Swal.fire({ icon: 'error', title: 'Server Error', text: 'An unexpected error occurred. Please try again later.' });
      setError('Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const roleDisplayNames = {
    facilitator: 'Facilitator',
    area_leader: 'Area Leader',
    admin: 'Admin'
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>Welcome Back</h1>
            <p>Select your role and sign in to continue</p>
          </div>

          <div className="role-selector-container">
            <div className="role-selector">
              {Object.keys(apiEndpoints).map((r) => (
                <button
                  key={r}
                  onClick={() => setRole(r)}
                  className={`role-button ${role === r ? 'active' : ''}`}
                >
                  {roleDisplayNames[r]}
                </button>
              ))}
            </div>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <span className="input-icon">
                <Icon path={ICONS.email} />
              </span>
              <input
                type="email"
                placeholder="Email Address"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <span className="input-icon">
                <Icon path={ICONS.lock} />
              </span>
              <input
                type="password"
                placeholder="Password"
                className="input-field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="login-button" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Signing In...</span>
                </>
              ) : (
                <>
                  <span>Sign In</span>
                  <Icon path={ICONS.arrow} className="icon arrow-icon" />
                </>
              )}
            </button>
          </form>
          
          { role !== 'admin' &&  (
            <>
              <div className="forgot-password">
                <button
                  type="button"
                  className="forgot-password-button"
                  onClick= {() => setShowForgotPassword(true)}
                >
                  Forgot Password?
                </button>
                {showForgotPassword && <ForgotPasswordFlow onClose={() => setShowForgotPassword(false)} role={role} />}
              </div>

              <div className="signup-section">
                <p>Don't have an account?</p>
                <button
                  type="button"
                  className="signup-button"
                  onClick={() => navigate(`/${role}-signup`)}
                >
                  Create a {roleDisplayNames[role]} Account
                </button>
              </div>
            </>
          )}
        </div>
        <footer className="login-footer">
          <p>&copy; {new Date().getFullYear()} EthicCraft. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Login;